import { useCallback } from 'react';
import { useLocation, useParams } from 'react-router-dom';

const useCopyTestLink = (
  testId: string,
  onOpenSnackbar?: (message: string) => void,
) => {
  const { search } = useLocation();
  const { id: curUrlParam } = useParams();

  return useCallback(() => {
    const windowUrl = window.location.href
      .replace(`/${curUrlParam}/`, '')
      .replace(search, '');

    const url = `${windowUrl.replace('/lineage', '/test-results')}/${testId}/`;

    navigator.clipboard.writeText(url);
    onOpenSnackbar?.('Copied to clipboard');
  }, [curUrlParam, search, testId, onOpenSnackbar]);
};

export default useCopyTestLink;
